/**
 * @constructor
 * @returns {GameConfig}
 */
export default function GameConfig() {

    this.symbolPosY = -80;

    this.reelsPositions = [
        { 'x': 180, 'y': this.symbolPosY },
        { 'x': 180 + (640 - 180) / 2, 'y': this.symbolPosY },
        { 'x': 640, 'y': this.symbolPosY },
        { 'x': 640 + (1280 - 180 - 640) / 2, 'y': this.symbolPosY },
        { 'x': 1280 - 180, 'y': this.symbolPosY }
    ];

    this.rowsCount = 3;

    this.symbolHeight = 206;
    this.symbolOffsetY = 0;

    this.hidePos = -9999;

    this.showPreinfo = true;
}

//GameConfig.prototype.init = function() {};